export const GLOBAL_ERRORS = {
  AsyncRequireError: 'AsyncRequireError',
  NewVersionAvailableError: 'NewVersionAvailableError',
  NoAvailableSpaceError: 'NoAvailableSpaceError',
};
